import {styled, css, forBrands} from "@core-ui/react-stitch";
import {RadioStyleFn, CommonProps} from "../types";

const getFocusVisibleStyles: RadioStyleFn = ({theme, checked, crossBrand}) => {
  const color = forBrands(
    theme,
    {
      at: (t) => t.crossBrand.color.b2,
      br: (t) => t.color.gray20,
      brfs: (t) => t.color.gray20,
      crossBrand: (t) => t.crossBrand.color.b2,
      gap: (t) => t.crossBrand.color.b2,
      gapfs: (t) => t.crossBrand.color.b2,
      on: (t) => t.crossBrand.color.b2,
    },
    crossBrand
  );

  const pos = checked ? "0.5px" : "0px";

  return css`
    outline: 0;
    box-shadow: ${pos} ${pos} 0 3px ${color};
  `;
};

const Input = styled.input<CommonProps>`
  // hide default input
  opacity: 0;
  position: absolute;

  /**
   * using hard-coded className instead of component selector until we use
   * https://github.com/emotion-js/emotion/releases/tag/%40emotion%2Fstyled%4011.0.0-next.3
  */
  &[data-focus-visible-added] ~ .fui_radio-button {
    ${getFocusVisibleStyles}
  }
`;

export default Input;
